import { render, staticRenderFns } from "./FloatingIcon2.vue?vue&type=template&id=2e1ff9d6&scoped=true"
import script from "./FloatingIcon2.vue?vue&type=script&lang=js"
export * from "./FloatingIcon2.vue?vue&type=script&lang=js"
import style0 from "./FloatingIcon2.vue?vue&type=style&index=0&id=2e1ff9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ff9d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsVerticalFloatingIcons: require('/app/components/Commons/VerticalFloatingIcons.vue').default})
